


function DavidFooter() {
    return(
        <div className="footer">
            <p id="small-text">not affiliated with Tuscarora HS but that would be pretty cool if i was</p>
            <p id="small-text"> You can reach me at 875497@lcps.org</p>
        </div>
    )
}
export default DavidFooter